import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'vatCode';

const vatCodeService = {
  getItems: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/data`,
      data,
    });
  },

  updateItem: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createItem: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  getVatCodeToDoc: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/getVatCodeToDoc`,
      data,
    });
  },

  getVatCode: (code) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(code)}`,
    });
  },
};
export default vatCodeService;
